<script lang="ts">
    import {Col } from "sveltestrap"
    import data from "../../../Data/ComponentData/Ui-kits/shadow/Shadow.json"
    import { Noshadow } from "../../../utils/Constant/Constant";
</script>
<Col xs="12">
    <h6 class="sub-title">{Noshadow}</h6>
</Col>
{#each data.noshadow as shadowItem}
  <Col sm="4">
    <div class="shadow-none p-25 shadow-showcase text-center">
      <h5 class="m-0 f-18">{shadowItem.name}</h5>
    </div>
  </Col>
{/each}